import React from 'react';

const About = () => {
  return (
    <div>
      {/* Header Section */}
      <section className="bg-gray-900 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">About Us</h1>
          <p className="text-xl text-gray-300">Excellence in Engineering Since 2017</p>
        </div>
      </section>

      {/* Company Profile */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-8 section-title">Company Profile</h2>
            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 mb-6">
                ATHENA PROCESS DESIGN & MANUFACTURING, an <span className="text-green font-semibold">ISO 9001: 2015, ISO 14001: 2015 certified company</span>, is a budding engineering company which deals with designing, Manufacturing, Fabrication and execution of projects in the arena of Dairy, Food Beverages, Pharmaceuticals and Herbal industries.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Established in 2017, Athena offers most effective product by providing the end to end solution right from designing of equipments, its manufacturing, and processing and installation services.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                The Equipments are designed and developed keeping in view hygiene requirement of Dairy, Food Beverages & Pharmacy application. Our key products include evaporators, dryers, dairy equipments, dairy/vegetables/fruit processing plants, mixers, storage tanks etc.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Athena is synonymous with <span className="text-accent font-semibold">best class quality and service</span> in the Food, Dairy & Biotech industry due to its people, technology, engineering capability and skill. The company has well established facilities and expertise to design and deliver the most reliable, efficient and innovative solutions for the process and overall project implementation for our valued clients.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                We are a powerful combination of Experienced, Well Qualified Engineers and extremely skilled workforce to be a dominant player in manufacturing of market-leading products on a worldwide basis.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8 section-title inline-block">Our Vision</h2>
            <p className="text-xl text-gray-700 mt-8">
              To provide <span className="text-green font-semibold">high energy efficient and cost effective</span> Projects/Equipment for Dairy, Food and Beverage industries across the globe through development of latest technologies.
            </p>
            <p className="text-lg text-gray-700 mt-6">
              We understand the need of the customers, who are under increasing economic, competitive and regulatory pressures and partner with them to design and deliver the most reliable, efficient and innovative solutions for the process and overall project implementation.
            </p>
          </div>
        </div>
      </section>

      {/* Manufacturing Unit */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-8 section-title">Manufacturing Unit</h2>
            <div className="bg-gray-50 p-8 rounded-lg">
              <p className="text-lg text-gray-700 mb-4">
                Our Manufacturing unit is located at <span className="text-accent font-semibold">Palwal, Haryana state</span> along the Delhi-Mathura Highway.
              </p>
              <p className="text-lg text-gray-700">
                Palwal city is already having a plethora of engineering business going on which gives us an advantage of better infrastructure facilities, well trained manpower etc.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-8 section-title">About Our Leader</h2>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold mb-4 text-accent">MR. M.K. SINGH</h3>
              <p className="text-lg text-gray-700 mb-6">
                <span className="font-semibold">B.E in Mechanical</span> has been successfully executing several projects and has a versatile experience of <span className="text-green font-semibold">24 Years</span> in the areas of:
              </p>
              <ul className="space-y-3 feature-list">
                <li className="text-lg text-gray-700">Engineering Consultancy in the field of food, Chemical and various Process Industries.</li>
                <li className="text-lg text-gray-700">Designing and Fabrication of Stainless Steel and Mild Steel equipments, Dairy, Food & Chemical Plants.</li>
                <li className="text-lg text-gray-700">Plant operations</li>
                <li className="text-lg text-gray-700">Erection and Commissioning of Dairy, Food & Chemical Plants.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Silent Features */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title inline-block">Silent Features of Our Equipment</h2>
            <div className="grid md:grid-cols-2 gap-6 mt-12">
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">High Tensile Strength</h3>
                  <p className="text-gray-600">Robust construction ensuring long-lasting performance</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Dimensional Accuracy</h3>
                  <p className="text-gray-600">Precision engineering for perfect fit and function</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">High Storage Capacity</h3>
                  <p className="text-gray-600">Optimized designs for maximum efficiency</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Resistance to Corrosion</h3>
                  <p className="text-gray-600">Premium materials for durability</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Superior Finish</h3>
                  <p className="text-gray-600">Professional-grade surface quality</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Durable Performance</h3>
                  <p className="text-gray-600">Built to withstand demanding operations</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Robust Construction</h3>
                  <p className="text-gray-600">Heavy-duty design for industrial use</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Easy Operation</h3>
                  <p className="text-gray-600">User-friendly controls and interfaces</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">High Efficiency</h3>
                  <p className="text-gray-600">Energy-efficient designs reducing operational costs</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="text-green text-2xl font-bold">✓</div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Smooth Functionality</h3>
                  <p className="text-gray-600">Reliable operation with minimal downtime</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8 section-title inline-block">Certifications</h2>
            <div className="grid md:grid-cols-2 gap-8 mt-12">
              <div className="bg-white p-8 rounded-lg shadow-lg card-hover">
                <div className="text-5xl font-bold text-accent mb-4">ISO 9001:2015</div>
                <h3 className="text-2xl font-semibold mb-3">Quality Management</h3>
                <p className="text-gray-600">Certified quality management systems ensuring consistent product excellence</p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-lg card-hover">
                <div className="text-5xl font-bold text-green mb-4">ISO 14001:2015</div>
                <h3 className="text-2xl font-semibold mb-3">Environmental Management</h3>
                <p className="text-gray-600">Committed to environmental responsibility and sustainable practices</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;